import { isEmpty } from 'lodash';

import { TLanguage } from 'config/tenancy';
import { ICustomer } from 'shared/domain/entities';

import getMissingCustomerFields from './getMissingCustomerFields';

export default function isCustomerRegistrationIncomplete(
  customer: ICustomer | null,
  tenancy: TLanguage,
) {
  const customerMeta = getMissingCustomerFields(customer, tenancy);

  if (!customerMeta) return false;

  return !isEmpty(customerMeta.fields);
}
